import { render, staticRenderFns } from "./Legacy_Parts.vue?vue&type=template&id=3d276a90&scoped=true&"
import script from "./Legacy_Parts.vue?vue&type=script&lang=js&"
export * from "./Legacy_Parts.vue?vue&type=script&lang=js&"
import style0 from "./Legacy_Parts.vue?vue&type=style&index=0&id=3d276a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d276a90",
  null
  
)

component.options.__file = "Legacy_Parts.vue"
export default component.exports